import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OrdenesServicioService } from '../../services/ordenes-servicio.service';

export interface VerPdfDialogData {
  orderId: string;
}

@Component({
  selector: 'app-ver-pdf',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatButtonModule,
  ],
  templateUrl: './ver-pdf.component.html',
  styleUrl: './ver-pdf.component.scss',
})
export class VerPdfComponent implements OnInit {
  url: SafeResourceUrl | null = null;
  messageError: string | null = null;
  loading = true;

  constructor(
    public dialogRef: MatDialogRef<VerPdfComponent>,
    private readonly sanitizer: DomSanitizer,
    private readonly ordenesServicioService: OrdenesServicioService,
    @Inject(MAT_DIALOG_DATA) public readonly data: VerPdfDialogData,
  ) {}

  ngOnInit(): void {
    this.getPdfOS(this.data.orderId);
  }

  private getPdfOS(orderId: string): void {
    if (!orderId) {
      this.showError('ID inválido para obtener el PDF.');
      return;
    }

    this.ordenesServicioService
      .getOrderPdfDownloadUrl(orderId, 'inline')
      .subscribe({
        next: (result) => {
          if (result.url) {
            this.url =
              this.sanitizer.bypassSecurityTrustResourceUrl(result.url);
            this.loading = false;
            return;
          }

          if (result.pdfStatus === 'FAILED') {
            this.showError(
              result.lastPdfError ||
                'No se pudo generar el PDF de la Orden de Servicio.',
            );
            return;
          }

          if (
            result.pdfStatus === 'PENDING' ||
            result.pdfStatus === 'PROCESSING'
          ) {
            this.showError(
              'El PDF de la Orden de Servicio todavía se está generando.',
            );
            return;
          }

          this.showError(
            'La Orden de Servicio no tiene un PDF disponible.',
          );
        },
        error: () => {
          this.showError(
            'Error al obtener el PDF de la Orden de Servicio.',
          );
        },
      });
  }

  private showError(message: string): void {
    this.messageError = message;
    this.loading = false;
  }
}
